import { render } from "./accounts2.vue?vue&type=template&id=7f2a0749"
import script from "./accounts2.vue?vue&type=script&lang=js"
export * from "./accounts2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__